import React, { useEffect } from "react";
import "../Styles/footer.css";
import { Link, useLocation } from "react-router-dom";
import { CartState } from "../Context/Context";

const Footer = (props) => {
  const { productDispatch } = CartState();
  let location = useLocation();
  useEffect(() => {}, [location]);

  return (
    <div style={{ display: location.pathname === "/admin" ? "none" : "block" }}>
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-1">
              <h4 className="footer-col-1">Have A Question?</h4>
              <ul>
                <li>
                  <Link to="/contactus" className="contact-us">
                    Contact Us
                  </Link>
                </li>
                <li>
                  <a
                    href="mailto:empirefootwear@gmail.com"
                    className="contact-1"
                  >
                    empirefootwear@gmail.com
                  </a>
                </li>
                <li>
                  <a href="tel:+919820043813" className="contact-1">
                    <p>
                      +91 9820043813 <br /> 11:00 AM to 6PM (Mon-Fri)
                    </p>
                  </a>
                </li>
              </ul>
            </div>
            <div className="footer-col">
              <h4>Shop</h4>
              <ul>
                <li>
                  <Link
                    to="/products"
                    onClick={() => {
                      productDispatch({
                        type: "FILTER_BY_CATEGORY",
                        payload: "all",
                      });
                    }}
                  >
                    All
                  </Link>
                </li>
                <li>
                  <Link
                    to="/products"
                    onClick={() => {
                      productDispatch({
                        type: "FILTER_BY_CATEGORY",
                        payload: "men",
                      });
                    }}
                  >
                    Men
                  </Link>{" "}
                </li>
                <li>
                  <Link
                    to="/products"
                    onClick={() => {
                      productDispatch({
                        type: "FILTER_BY_CATEGORY",
                        payload: "women",
                      });
                    }}
                  >
                    Women
                  </Link>{" "}
                </li>
              </ul>
            </div>
            <div className="footer-col">
              <h4>Know</h4>
              <ul>
                <li>
                  <Link to="/journey">The Journey</Link>
                </li>
                <li>
                  <Link to="/" onClick={props.click}>
                    Why Dokmen
                  </Link>
                </li>
                <li>
                  <Link to="#" onClick={props.showAlert}>
                    Blog
                  </Link>
                </li>
                <li>
                  <Link to="#" onClick={props.showAlert}>
                    FAQ
                  </Link>
                </li>
                <li>
                  <Link to="/affiliate">Become an Affiliate</Link>
                </li>
                <li>
                  <Link to="/affiliate">Corporate Gifting</Link>
                </li>
              </ul>
            </div>
            <div className="footer-col">
              <h4>Guides</h4>
              <ul>
                <li>
                  <a
                    href="https://api.whatsapp.com/send?phone=+919820043813&text=I want to track my order"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Track Your Order
                  </a>
                </li>
                <li>
                  <a
                    href="https://api.whatsapp.com/send?phone=+919820043813&text=I want to ask about Return and Exchange"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Schedule a Return / Exchange
                  </a>
                </li>
                <li>
                  <Link to="#" onClick={props.showAlert}>
                    Care your product
                  </Link>
                </li>
                <li>
                  <Link to="/returnpolicy">Returns Policy</Link>
                </li>
                <li>
                  <Link to="/privacypolicy">Privacy Policy</Link>
                </li>

                <li>
                  <Link to="/terms&condition">Terms & Conditions</Link>
                </li>
                <li>
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#loginModal"
                    className="btn btn-link"
                    style={{
                      padding: "0",
                      textDecoration: "none",
                      color: "white",
                    }}
                  >
                    Log In
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
